import styled, { css } from 'styled-components';

import { PlanFeatureText } from '../Wrapper';
import { PlanFeatureEffect, PlanFeatureProps } from '../types';

const effectsStyle: { [key in PlanFeatureEffect]: ReturnType<typeof css> } = {
  new: css``,
  line_through: css`
    color: #919eaa;
    text-decoration: line-through;
  `,
  coming_soon: css`
    ${PlanFeatureText}:after {
      content: 'Coming soon!';
      font-weight: 700;
      font-size: 12px;
      height: 20px;
      line-height: 20px;
      color: #919eaa;
      background: #f5f7fa;
      border-radius: 5px;
      padding: 0 5px;
      display: inline-block;
      white-space: nowrap;
      margin-left: 5px;
    }
  `
};

export const ContentWrapper = styled.div<Pick<PlanFeatureProps, 'effects'>>`
  ${({ effects }) => effects?.map(effect => effectsStyle[effect])}
`;
